'use client'

// src/components/Eligibility/index.js
import Eligibility from './Eligibility'

export default Eligibility
